import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

export const sliderGifts = (slider) => {
    new Swiper(slider, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 24,
        pagination: {
            el: slider.querySelector('.swiper-pagination') as HTMLElement,
            clickable: true,
        },
        navigation: {
            nextEl: slider.querySelector('.swiper-button-next') as HTMLElement,
            prevEl: slider.querySelector('.swiper-button-prev') as HTMLElement,
        },
    })
}
